"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatTimeExtremes = exports.formatTime = exports.isValidValue = exports.isNoData = exports.calculateMeasurementStats = void 0;
const moment_1 = __importDefault(require("moment"));
const dateFormat_1 = require("../types/dateFormat");
const calculateMeasurementStats = (measurements) => {
    if (measurements.length === 0) {
        return { min: 0, max: 0, avg: 0 };
    }
    const values = measurements.map((m) => m.value);
    const min = Math.round(Math.min(...values));
    const max = Math.round(Math.max(...values));
    const avg = Math.round(values.reduce((sum, value) => sum + value, 0) / values.length);
    return { min, max, avg };
};
exports.calculateMeasurementStats = calculateMeasurementStats;
const isNoData = (...values) => {
    return values.some((value) => value === undefined ||
        value === null ||
        value === Infinity ||
        value === -Infinity ||
        isNaN(value));
};
exports.isNoData = isNoData;
const isValidValue = (value) => {
    return value !== null && value !== undefined && isFinite(value);
};
exports.isValidValue = isValidValue;
const formatTime = (minTime, maxTime) => {
    const formatDate = (time) => {
        if (!time)
            return { date: null, time: null };
        // Check if time is a valid date string before creating moment object
        const dateMoment = (0, moment_1.default)(time, moment_1.default.ISO_8601);
        // Check if the created moment is valid
        if (!dateMoment.isValid()) {
            return { date: null, time: null };
        }
        const dateString = dateMoment.format(dateFormat_1.DateFormat.us);
        const timeString = dateMoment.format(dateFormat_1.DateFormat.time_with_seconds);
        return { date: dateString, time: timeString };
    };
    return {
        formattedMinTime: formatDate(minTime),
        formattedMaxTime: formatDate(maxTime),
    };
};
exports.formatTime = formatTime;
const formatTimeExtremes = (min, max, useFullDayFormat = false) => {
    // Make sure min and max are valid numbers before creating moment objects
    if (!(0, exports.isValidValue)(min) || !(0, exports.isValidValue)(max)) {
        return {
            formattedMinTime: { date: null, time: null },
            formattedMaxTime: { date: null, time: null },
        };
    }
    // Force UTC handling
    const minDate = moment_1.default.utc(min);
    const maxDate = moment_1.default.utc(max);
    // Verify both dates are valid
    if (!minDate.isValid() || !maxDate.isValid()) {
        return {
            formattedMinTime: { date: null, time: null },
            formattedMaxTime: { date: null, time: null },
        };
    }
    // Check if both timestamps fall on the same day
    const sameDay = minDate.isSame(maxDate, "day");
    // Determine if the minimum timestamp is exactly at the start of its day
    const isMinAtStart = minDate.isSame(minDate.clone().startOf("day"));
    // Determine if the maximum timestamp is exactly at the end of its day
    const isMaxAtEnd = maxDate.isSame(maxDate.clone().endOf("day"));
    return {
        formattedMinTime: {
            date: minDate.format(dateFormat_1.DateFormat.us),
            time: useFullDayFormat && sameDay && isMinAtStart
                ? "00:00:01"
                : minDate.format(dateFormat_1.DateFormat.time_with_seconds),
        },
        formattedMaxTime: {
            date: maxDate.format(dateFormat_1.DateFormat.us),
            time: useFullDayFormat && sameDay && isMaxAtEnd
                ? "00:00:00"
                : maxDate.format(dateFormat_1.DateFormat.time_with_seconds),
        },
    };
};
exports.formatTimeExtremes = formatTimeExtremes;
